export const LABEL_TYPES = {
  DISCOUNT: 'discount',
  ACTIVITY_TYPE: 'type',
  NOVELTY: 'novelty',
} as const;

export const DAY_PARTS = {
  MORNING: 'morning',
  DAY: 'day',
  EVENING: 'evening',
  NIGHT: 'night',
} as const;

export const DAY_PARTS_IN_ORDER = [
  DAY_PARTS.MORNING,
  DAY_PARTS.DAY,
  DAY_PARTS.EVENING,
  DAY_PARTS.NIGHT,
];

export const ACTIVITY_TYPES = {
  INDIVIDUAL: 'individual',
  GROUP: 'group',
} as const;

export const CAT_TYPES = {
  CATEGORY: 'CATEGORY',
  MOVING_TYPE: 'MOVING_TYPE',
  INTEREST: 'INTEREST',
};

export const CAT_IDS_BY_TYPES = {
  [CAT_TYPES.CATEGORY]: [58, 76, 69],
  [CAT_TYPES.MOVING_TYPE]: [20, 1, 64, 30],
  // 18 - на самом деле не INTEREST, а FEATURE, но в данном контексте это не имеет значения.
  [CAT_TYPES.INTEREST]: [33, 19, 10, 11, 52, 86, 5, 18],
};

export const MINI_GROUP_ID = 88;

export const CARD_HEIGHT = 298;
export const CARD_WITH_DESCRIPTION_HEIGHT = 366;
// in sync with src/blocks/ActivityCompactCard/ActivityCompactCard.scss container height.
export const COMPACT_CARD_HEIGHT = 228;
